import React, { useEffect, useState } from 'react';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { ErrorButton, SecondaryButton } from "../UI";
import { getOrgLevels } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';

const CreateTemplateLevelModal = ({ setLevelModal, saveTemplateHandler, levels, setLevels }) => {
    const { userData } = useUserContext();
    const [availableLevels, setAvailableLevels] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchOrgLevels = async () => {
            try {
                const orgLevels = await getOrgLevels(userData?.token, userData?.selectedOrganization?.org_token);
                setAvailableLevels(orgLevels.data);
            } catch (error) {
                console.error("Error fetching organization levels:", error);
            }
        };
        fetchOrgLevels();
    }, [userData]);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleLevelChange = (level) => {
        setLevels((prevLevels) => 
            prevLevels.includes(level)
                ? prevLevels.filter((l) => l !== level)
                : [...prevLevels, level]
        );
    };

    const saveHandler = async () => {
        try {
            saveTemplateHandler();
            setLevelModal(false);
        } catch (error) {
            setError("Error saving selected levels.");
        }
    };

    return (
        <PrimaryModal 
            title="Edit Levels" 
            hideModal={() => setLevelModal(false)}
        >
            <div className='p-6 space-y-6'>
                <div className="flex flex-col space-y-2 mb-6 gap-8">
                    <div className='relative'>
                        <button
                            type="button"
                            onClick={toggleDropdown}
                            className="w-full p-3 text-left bg-gray-100 border border-gray-300 rounded-lg focus:outline-none"
                        >
                            {levels.length > 0 
                                ? `${levels.length} level's selected` 
                                : "Select levels"}
                        </button>
                        
                        {dropdownOpen && (
                            <div className="absolute mt-2 bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto w-full z-10">
                                {availableLevels.length && availableLevels.map((level) => (
                                    <label key={level._id} className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                        <input
                                            type="checkbox"
                                            checked={levels.includes(level.id)}
                                            onChange={() => handleLevelChange(level.id)}
                                            className="mr-2"
                                        />
                                        {level.id}
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>

                    {error && <p className="text-red-500 text-sm">{error}</p>}

                    <div className="flex space-x-4">
                        <ErrorButton handleClick={saveHandler}>Save</ErrorButton>
                        <SecondaryButton handleClick={() => setLevelModal(false)}>Cancel</SecondaryButton>
                    </div>
                </div>
            </div>
        </PrimaryModal>
    );
};

export default CreateTemplateLevelModal;
